/**
 * Smart Shikka AI Core — Waza Workflow Planner Preview Registry
 * PR82: No skill execution. Deep-frozen preview metadata.
 * Adapted from Waza (https://github.com/tw93/Waza), MIT license.
 */
const BLOCKED_ACTIONS = [
    { action: "execute_waza_skill", reason: "No Waza skill execution in PR82" },
    { action: "run_workflow", reason: "No workflow run in PR82" },
    { action: "run_agent", reason: "No agent run in PR82" },
    { action: "run_plugin", reason: "No plugin run in PR82" },
    { action: "fetch_external", reason: "No external fetch in PR82" },
    { action: "network_call", reason: "No network calls in PR82" },
    { action: "provider_call", reason: "No provider calls in PR82" },
    { action: "db_write", reason: "No DB writes in PR82" },
    { action: "supabase_call", reason: "No Supabase calls in PR82" },
    { action: "secret_read", reason: "No secret access in PR82" },
    { action: "file_read", reason: "No file reads in PR82" },
    { action: "file_write", reason: "No file writes in PR82" },
    { action: "child_process", reason: "No child_process in PR82" },
    { action: "shell_command", reason: "No shell commands in PR82" },
    { action: "browser_action", reason: "No browser automation in PR82" },
    { action: "desktop_action", reason: "No desktop automation in PR82" },
];
function deepFreeze(obj) {
    Object.freeze(obj);
    for (const value of Object.values(obj)) {
        if (value && typeof value === "object" && !Object.isFrozen(value)) {
            deepFreeze(value);
        }
    }
    return obj;
}
const skills = [
    {
        id: "think",
        sourceSkillId: "think",
        displayName: "Smart Shikka AI Think Skill Preview, adapted from Waza",
        description: "Thinking/reasoning skill planning preview — metadata only, no execution",
        skillCategory: "reasoning",
        previewOnly: true,
        skillExecutionAllowedInPr82: false,
        workflowRunAllowedInPr82: false,
        agentRunAllowedInPr82: false,
        networkAllowedInPr82: false,
        providerAllowedInPr82: false,
        blockedActions: [...BLOCKED_ACTIONS],
        futurePrScope: ["Future: Smart Shikka Assistant planning integration with owner approval"],
        notes: ["Source: Waza SKILL.md (think)"],
    },
    {
        id: "check",
        sourceSkillId: "check",
        displayName: "Smart Shikka AI Check Skill Preview, adapted from Waza",
        description: "Verification/check skill planning preview — metadata only, no execution",
        skillCategory: "verification",
        previewOnly: true,
        skillExecutionAllowedInPr82: false,
        workflowRunAllowedInPr82: false,
        agentRunAllowedInPr82: false,
        networkAllowedInPr82: false,
        providerAllowedInPr82: false,
        blockedActions: [...BLOCKED_ACTIONS],
        futurePrScope: ["Future: Smart Shikka Assistant check task integration with owner approval"],
        notes: ["Source: Waza SKILL.md (check)"],
    },
    {
        id: "hunt",
        sourceSkillId: "hunt",
        displayName: "Smart Shikka AI Hunt Skill Preview, adapted from Waza",
        description: "Search/discovery skill planning preview — metadata only, no execution",
        skillCategory: "discovery",
        previewOnly: true,
        skillExecutionAllowedInPr82: false,
        workflowRunAllowedInPr82: false,
        agentRunAllowedInPr82: false,
        networkAllowedInPr82: false,
        providerAllowedInPr82: false,
        blockedActions: [...BLOCKED_ACTIONS],
        futurePrScope: ["Future: Smart Shikka Assistant hunt/search task with owner approval"],
        notes: ["Source: Waza SKILL.md (hunt)"],
    },
    {
        id: "read",
        sourceSkillId: "read",
        displayName: "Smart Shikka AI Read Skill Preview, adapted from Waza",
        description: "Reading/comprehension skill planning preview — metadata only, no execution",
        skillCategory: "comprehension",
        previewOnly: true,
        skillExecutionAllowedInPr82: false,
        workflowRunAllowedInPr82: false,
        agentRunAllowedInPr82: false,
        networkAllowedInPr82: false,
        providerAllowedInPr82: false,
        blockedActions: [...BLOCKED_ACTIONS],
        futurePrScope: ["Future: Smart Shikka Assistant read/comprehension task with owner approval"],
        notes: ["Source: Waza SKILL.md (read)"],
    },
    {
        id: "health",
        sourceSkillId: "health",
        displayName: "Smart Shikka AI Health Skill Preview, adapted from Waza",
        description: "Health/wellness skill planning preview — metadata only, no execution",
        skillCategory: "wellness",
        previewOnly: true,
        skillExecutionAllowedInPr82: false,
        workflowRunAllowedInPr82: false,
        agentRunAllowedInPr82: false,
        networkAllowedInPr82: false,
        providerAllowedInPr82: false,
        blockedActions: [...BLOCKED_ACTIONS],
        futurePrScope: ["Future: Smart Shikka Assistant health task with owner approval"],
        notes: ["Source: Waza SKILL.md (health)"],
    },
];
const registry = deepFreeze({ skills });
export function getWazaWorkflowSkillPreviews() {
    return registry.skills;
}
export function getWazaWorkflowSkillPreviewById(id) {
    return registry.skills.find((s) => s.id === id);
}
export { registry as wazaWorkflowPlannerPreviewRegistry };
//# sourceMappingURL=wazaWorkflowPlannerPreviewRegistry.js.map